/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/


/* ----------------------------------------------------------------------------------------------------------------
-------------------------------------------------------------------------------------------------------------------
-- Contains texts
-------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------------------------------------------------------------------*/
class Texts {
    // Title of the webpage in the header component
    static title_header = "Sunlit3D Dataset";
    // Version number of the app
    static version_header = "v 1.0.0"
    // Footer copyright text
    //static copyright_footer = "Copyright © 2024 Herbert M. Potechius. All Rights Reserved"
    static copyright_footer = "Copyright © 2024 Anonymous. All Rights Reserved"

    static sidebar_algorithms = "ALGORITHMS"
    static sidebar_items = "ITEMS"
    static sidebar_database = "DATABASE"
    static sidebar_objects = "OBJECTS"
    static sidebar_settings = "SETTINGS"
}


export default Texts